import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import ActivityCard from "./ActivityCard";
import '../Activities.css';
import { useTranslation } from 'react-i18next';
import { getTranslatedActivity } from '../translations/activityTranslations';


function ActivityDetails() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const activities = location.state?.activities || [];
    const [expandedIndex, setExpandedIndex] = useState(null);

    return (
        <div className="container">
            <h2>
                {activities.length > 0
                    ? getTranslatedActivity(activities[0], i18n.language).name
                    : (i18n.language === 'en' ? "Activity" : "กิจกรรม")}
            </h2>

            <button className="d-flex justify-content-start mb-3"
                style={{
                    backgroundColor: "#D6E6FF",
                    color: "#004085",
                    borderRadius: "5px"
                    }}
                onClick={() => navigate(-1)}>
                {i18n.language === 'en' ? '⬅️ Back' : '⬅️ย้อนกลับ'}
            </button>
            <Row className="g-4">
                {activities.map((activity, index) => {
                    const translated = getTranslatedActivity(activity, i18n.language);
                    return (
                    <Col key={index} md={4}>
                        <ActivityCard
                            name={translated.name}
                            description={translated.description}
                            image={activity.imgURL}
                            expanded={expandedIndex === index}
                            onToggle={() => setExpandedIndex(expandedIndex === index ? null : index)}
                        />
                    </Col>
                    );
                })}
            </Row>
        </div>
    );
}

export default ActivityDetails;